module.exports = __webpack_public_path__ + "img/section_3_asset_3.5b01ff39.png";